import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Button, Grid, Stack } from '@mui/material';
import 'ag-grid-enterprise';
import { useParams } from "react-router-dom";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from 'react-select';
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";

const BundleProductOptions = ({ productList, deletedProduct, type, setSaveResponse, onSelectionChanged, bundleProductData ,  setBundleProductData, frontOptionData, setFrontOptionData, rangeOptionData, setRangeOptionData }) => {
    const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
    const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
    const rangeVariationUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.rangeVariations}`;
    const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.carcasses}`;
    const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.handles}`;
    const posMaterialUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.posMaterials}`;
    const genericProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.generics}`;
    const [rowData, setRowData] = useState([]);
    const perPage = 10;
    const [error, setError] = useState("")
    const gridRef = useRef();
    const [productType, setProductType] = useState("");
    const [pageSize, setPageSize] = useState("10");
    // const [frontOptionData, setFrontOptionData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
        {
            dndSource: true,
            maxWidth: 90,
            checkboxSelection: true,
            filter: false
        },
        { field: '_class', headerName: "PRODUCT TYPE" },
        { field: 'productId', headerName: 'PRODUCT ID', },
        { field: 'productName', headerName: "PRODUCT NAME" },
        { field: 'vendor', headerName: 'VENDOR' },
        { field: 'priceGroup', headerName: 'Price Group', valueFormatter: (value) => value.value?.pgId }
        // { field: 'new' , headerName:"New PRODUCT"}
    ]);

    const productData = [
        { value: "All", label: "All Product" },
        { value: "Range", label: "Range" },
        { value: "Front Options", label: "Front Options" },
        { value: "Carcass", label: "Carcass" },
        { value: "Handle", label: "Handle" },
        { value: "POSMaterial", label: "Pos Material" },
        { value: "Generic", label: "Generic" },
    ]

    const pageOptions = [
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "50", label: "50" },
        { value: "100", label: "100" },
    ]


    const findMaterialMasterProduct = async () => {

        const data = { materialStatus: "true" }
        try {
            const list = await OAuthService.addData(findAllProductUrl, data);
            let allProduct = list.data?.filter((variation) => !productList?.some((product) => variation.id === product.id));
            allProduct = allProduct.map((product) => {
                const vendorName = product.vendor.map((vendors) => {
                    const name = vendors.name;
                    const shortKey = vendors.shortKey;
                    const merge = `${name} ${shortKey}`
                    return merge
                });
                const productName = product.productName?.toUpperCase();
                product.vendor = vendorName.join(" , ");
                product.productName = product.new === true ? `${productName} (new)` : productName;
                const type = product._class;
                if (type === "Carcass") {
                    const carcassesLink = carcassUrl + "/" + product.id;
                    product._links = { self: { href: carcassesLink } }
                }
                if (type === "Range") {
                    const rangesLink = rangeUrl + "/" + product.id;
                    product._links = { self: { href: rangesLink } }
                }
                if (type === "Handle") {
                    const handlesLink = handleUrl + "/" + product.id;
                    product._links = { self: { href: handlesLink } }
                }
                if (type === "Front Options") {
                    const rangeVariationLink = rangeVariationUrl + "/" + product.id;
                    product._links = { self: { href: rangeVariationLink } }
                }
                if (type === "POSMaterial") {
                    const posMaterialLink = posMaterialUrl + "/" + product.id;
                    product._links = { self: { href: posMaterialLink } }
                }
                if (type === "Generic") {
                    const genericLink = genericProductUrl + "/" + product.id;
                    product._links = { self: { href: genericLink } }
                }
                return product
            })
            const rangeVariation = allProduct.filter((product) => product._class === "Front Options")
            setFrontOptionData(rangeVariation)
            const filteredProduct = allProduct.filter((product) => product._class !== "ProductBundle")
            setRowData(filteredProduct);
            setBundleProductData(filteredProduct);
            const filteredRanges = allProduct.filter((product) => product._class === "Range");
            setRangeOptionData(filteredRanges);
        } catch (error) {
            setError(error.message);
        }
    }
    useEffect(() => {
        const RowData = rowData?.filter((row) => !productList?.some((product) => row.id === product.id));
        const SelectedProducts = bundleProductData?.filter((row) => !productList?.some((product) => row.id === product.id));
        const variationProducts = frontOptionData?.filter((variation) => !productList?.some((product) => variation.id === product.id));
        const rangeProducts = rangeOptionData?.filter((variation) => !productList?.some((product) => variation.id === product.id));
        // if (RowData) {
        //     setRowData(RowData);
        // }
        if (SelectedProducts) {
            setBundleProductData(SelectedProducts);
        }

        if (variationProducts) {
            setFrontOptionData(variationProducts)
        }
        if(rangeProducts) {
            setRangeOptionData(rangeProducts)
        }
    }, [productList,productType])

    useEffect(() => {
        if (deletedProduct.length > 0) {
            setRowData([...rowData, ...deletedProduct]);
        }
    }, [deletedProduct])

    const onGridReady = useCallback((params) => {
        findMaterialMasterProduct();
        if(type === "ranges"){
            gridRef.current.columnApi.setColumnVisible("_class", false);
        }else{
            gridRef.current.columnApi.setColumnVisible("_class", true);
        }
        if(type === "rangeVariations") {
            gridRef.current.columnApi.setColumnVisible("priceGroup", true);
        } else {
            gridRef.current.columnApi.setColumnVisible("priceGroup", false);
        }
    }, [rowData]);

    const handleProductChange = (data) => {
        setProductType(data.value);
        const selectedData = rowData.filter((product) => {
            if (data.value === "All") {
                return product
            }
            else {
                return product._class === data.value
            }
        });
        setBundleProductData(selectedData);
    }

    const onPageSizeChanged = (data) => {
        setPageSize(data.value);
    }

    return (
        <div
            style={{ height: "500px" }}
        >
            <Grid className='flex justify-between mb-16 mt-16'>
                <Grid>
                    <Button
                        className="mt-24"
                        onClick={() => setSaveResponse(false)}
                        variant="contained" color="warning"
                    >
                        <FuseSvgIcon>heroicons-outline:arrow-circle-left</FuseSvgIcon>
                    </Button>
                </Grid>
                <Grid className='flex'>
                    {type === 'productBundles' && <Stack className=" w-200 mr-14">
                        <label>Select Product Type </label>
                        <Select
                            name="productType"
                            placeholder="All products"
                            value={(productType && productData) && productData.filter(obj => productType === obj.value)}
                            onChange={handleProductChange}
                            options={productData}
                            // isDisabled={saveResponse}
                            styles={customStyles()}
                            className="select"
                        />
                    </Stack>}
                    <Stack className="w-120">
                        {/* <label>Page Size</label>
                        <Select
                            name="page size"
                            value={(pageSize && pageOptions) && pageOptions.filter(obj => pageSize === obj.value)}
                            onChange={onPageSizeChanged}
                            options={pageOptions}
                            // isDisabled={saveResponse}
                            styles={customStyles()}
                        // className="select"
                        /> */}
                        {/* <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !productType) ? "This field is required" : validError.productType}</Typography> */}
                    </Stack>

                </Grid>
            </Grid>

            <div className="mb-16">
                {type === 'ranges' ? <label>Available Front Options</label> : type === 'productBundles' ? <label >Available Bundle Product</label>: <label >Available Range Options</label>}

            </div>
            <AgGridTable
                rowData={type === "ranges" ? frontOptionData : type === "productBundles" ? bundleProductData : rangeOptionData}
                columnDefs={columnDefs}
                gridRef={gridRef}
                onGridReady={onGridReady}
                paginationPageSize={pageSize}
                cacheBlockSize={perPage}
                hideCheckbox={true}
                tableClassName={"header-cell-line"}
                floatingFilter={true}
                editable={false}
                onSelectionChanged={onSelectionChanged}
                saveGridStateName={type === 'ranges' ? 'selectFrontOptions' :  type === "productBundles" ? 'selectBundleProduct' : 'selectedRangeOptions'}
            />
        </div>
    )
}

export default BundleProductOptions